import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { positionsTypes } from "../constantes/actionTypes"

export const positionsActions = {
    getAllPositions: () => (
        createMiddlewareAction({
            successType: positionsTypes.GET_ALL_POSITIONS_SUCCESS,
            failureType: positionsTypes.GET_ALL_POSITIONS_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_ALL_POSITIONS
        })
    ),
    updatePosition: (position) => (
        createMiddlewareAction({
            successType: positionsTypes.UPDATE_POSITION_SUCCESS,
            failureType: positionsTypes.UPDATE_POSITION_FAILURE,
            method: "PUT",
            endpoint: endpoints.UPDATE_POSITIONS,
            body: position
        })
    ),
    deletePositionById: (idPosition) => (
        createMiddlewareAction({
            successType: positionsTypes.DELETE_POSITION_SUCCESS,
            failureType: positionsTypes.DELETE_POSITION_FAILURE,
            method: "DELETE",
            endpoint: endpoints.DELETE_POSITIONS(idPosition)
        })
    ),
    newPosition: (position) => (
        createMiddlewareAction({
            successType: positionsTypes.NEW_POSITION_SUCCESS,
            failureType: positionsTypes.NEW_POSITION_FAILURE,
            method: "POST",
            endpoint: endpoints.NEW_POSITIONS,
            body: position
        })
    )
}